module.exports = __webpack_public_path__ + "img/0Q3A2889_L.c70cf9ec.webp";